// extracted by mini-css-extract-plugin
export default {"allProducts":"AllProducts_allProducts__H3rWj","productsContainer":"AllProducts_productsContainer__e2+Rr","productsCardsContainer":"AllProducts_productsCardsContainer__WJXfq"};